import { useGetActivityQuery } from '../../generated/types-orchestration'
import type { SingleActivity } from './types'

interface UseActivityHook {
  loading: boolean
  activity?: SingleActivity
  error?: string
}

export const useActivity = ({ activityId }: { activityId: string }): UseActivityHook => {
  const { data, loading, error } = useGetActivityQuery({
    variables: {
      id: activityId
    },
    fetchPolicy: 'network-only'
  })
  if (error) {
    return {
      loading: false,
      error: error.message
    }
  }

  return {
    activity: data?.activity?.activity,
    loading
  }
}
